import React from 'react';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const RefreshActionMenu = ({ onClick, readStatus }) => (
  <RibbonMenu
    className="aridhia-refresh-action-menu"
    disabled={readStatus === states.PENDING}
    icon="refresh"
    loading={readStatus === states.PENDING}
    message="actions.refresh"
    name="refresh"
    onClick={onClick}
  />
);

export default RefreshActionMenu;
